import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { userChanged } from 'features/users/hooks/user.slice';
import ToggleSwitch from 'shared/components/atoms/ToggleSwitch';
import { Button } from 'shared/components/display';

import { apiAction } from 'shared/actions/api';
import { CREATOR_COPY } from 'shared/config/copy';
import { API_USER_ROUTES } from 'shared/config/routes/api/apiUserRoutes';
import { BUTTON_VARIANTS } from 'shared/styles/button';
import { CreatorUser } from 'shared/typings/user';

import CreatorWarningStatusFormModal from '../../molecules/CreatorWarningStatusFormModal';

interface Props {
  user: CreatorUser;
  className?: string;
  onClick?: () => void;
}

const WarningStatusButton: React.FC<Props> = ({ user, className, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const removeWarningStatus = () => {
    const { hasWarningStatus } = user;

    dispatch(
      apiAction({
        path: {
          route: API_USER_ROUTES.WARNING_STATUS_CREATOR,
          variables: { userId: user.id },
        },
        method: 'PATCH',
        data: {
          hasWarningStatus: !hasWarningStatus,
        },
        successToast: {
          message: CREATOR_COPY.SUCCESS_WARNING_STATUS,
        },
        successAction: userChanged,
      }),
    );
    onClick && onClick();
  };

  return (
    <>
      <Button
        onClick={user.hasWarningStatus ? removeWarningStatus : () => setIsOpen(!isOpen)}
        className={className}
        data-cy="warning-status-button"
        variant={BUTTON_VARIANTS.OPTION}
      >
        <ToggleSwitch toggledOn={user.hasWarningStatus} label={CREATOR_COPY.BUTTON_WARNING_STATUS} rightAlign />
      </Button>
      <CreatorWarningStatusFormModal
        isOpen={isOpen}
        onRequestClose={() => {
          setIsOpen(false);
          onClick && onClick();
        }}
        user={user}
      />
    </>
  );
};

export default WarningStatusButton;
